import React, { useState } from "react";
// components
import ExperienceCard from "../components/experience/ExperienceCard";
import HeadingAnimate from "../components/animate/HeadingAnimate";
import LoadAnimate from "../components/animate/LoadAnimate";
// mocks
import { experience } from "../mock/experience";
import XpItem from "../components/experience/XpItem";
// ----------------------------------------------------------------------

export default function Experience() {
  const [activeIndex, SetActiveIndex] = useState(null);

  const toggleExp = (index) => {
    SetActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <div id="experience" />
      <div
        className=" bg-[#131313] bg-blend-overlay bg-cover bg-fixed bg-center"
        /*style={{ backgroundImage: `url('/assets/backImg/bg9.jpg')` }}*/
      >
        <section className="container mx-auto pt-12 text-center sm:py-20">
          <h2 className=" text-center font-lato text-3xl font-semibold text-primary-700 dark:text-cyan-400 sm:text-5xl">
            WORK EXPERIENCE
          </h2>

          <LoadAnimate amount={0}>
            <div className="container mx-auto my-5 flex flex-col items-center p-5 md:flex-col">
              {experience.map((item, index) => {
                return (
                  // <ExperienceCard {...item} key={"exp" + i}></ExperienceCard>
                  <div className="relative h-full w-full" key={index}>
                    <div className="invisible absolute flex h-full w-[200px] flex-col items-center md:visible">
                      <div className=" h-full w-1 bg-[#283247]"></div>
                      <div className="my-5 h-[15px] w-[15px] flex-none rounded-full bg-[#c9e270] shadow-[0_0_30px_15px_#0a80ee85]"></div>
                      <div className=" h-full w-1 bg-[#283247]"></div>
                    </div>
                    <div className="mb-5 rounded-md bg-[#222121] border-[1px] border-solid border-[#464646] p-5 md:my-3 md:mb-0 md:ml-[200px] md:flex md:flex-row-reverse md:items-start lg:px-10">
                      <div className={`w-full cursor-pointer ${activeIndex !== index ? ' transform transition duration-500 hover:scale-105' : ''}`}>
                        <div onClick={() => toggleExp(index)}>
                          <div className="mt-3 text-left text-base text-[#efbc44] md:text-xl">
                            {item.position}
                          </div>

                          <div className="flex flex-row items-center justify-between">
                            <div className="flex">
                              {/* <img src={logo} alt={"logo"} className=" mr-5 h-[40px]"></img> */}
                              <div className="text-base font-bold text-[#5a9bcb] md:text-lg">
                                {item.company}
                              </div>
                            </div>

                            <div className=" text-left text-sm font-semibold text-[#b73232] md:text-base">
                              {item.duration}
                            </div>
                          </div>
                        </div>
                        {activeIndex === index && (
                          <div className="py-4 text-sm text-[#464646] dark:text-[#464646] md:text-base">
                            {item.descriptions.map((description, id) => {
                              return (
                                <XpItem
                                  key={"des" + id}
                                  paragraph={description}
                                />
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </LoadAnimate>
        </section>
      </div>
    </>
  );
}
